<template>
  <div class="tableConta">
    <Table :columns="columns" border :data="date" @on-selection-change="selectFn">
      <template slot="id" slot-scope="{row,index}">
        <span v-if="row.source == 1">{{row.id}}</span>
        <span v-else>{{row.shareId}}</span>
      </template>
      <template slot="createBy" slot-scope="{row,index}">
          <template v-if="row.modifyBy!= null && row.modifyBy !=''">
            <span v-if="row.modifyBy == 'AdminRule'">官方平台</span>
            <span v-else>{{row.createBy}}</span>
          </template>
          <template v-else>{{row.createBy}}</template>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" type="success" :disabled="row.source != 1" @click="editRules(row)">编辑</Button>
        <Button type="info" size="small" style="margin:0 10px;" @click="applySafetyRule(row)">分配到安全组</Button>
        <Button size="small" type="error" @click="swichMatchFn(4, row.id)">删除</Button>
      </template>
      <template slot-scope="{row,index}" slot="source">
        <span v-if="row.source == 1">原创</span>
        <span v-else>共享</span>
      </template>
      <template slot-scope="{row,index}" slot="version">
        <template v-if="row.source == 3 && row.shareVersion > row.version">
          <span class="errorCol txtUnderline" @click="askUpdate(row)">点击升级</span>
        </template>
        <template v-else>
          {{ row.version }}
        </template>
      </template>
      <template slot-scope="{row,index}" slot="status">
        <switchc :value="row.isOpen" style="margin-left:6px;" @change="swichFn(row)">开启</switchc>
      </template>
    </Table>

    <div class="pageCon clearfix">
      <Button class="fl" :disabled="selectVal.length == 0" @click="swichMatchFn(1)">启用<b
          v-if="selectVal.length > 0">(已选{{
          selectVal.length
          }})</b></Button>
      <Button class="fl" style="margin:0 10px;" :disabled="selectVal.length == 0" @click="swichMatchFn(2)">禁用<b
          v-if="selectVal.length > 0">(已选{{
          selectVal.length
          }})</b></Button>
      <Button class="fl" :disabled="selectVal.length == 0" @click="swichMatchFn(3)">删除<b
          v-if="selectVal.length > 0">(已选{{
          selectVal.length
          }})</b></Button>
      <Page class="fr" @on-change="pagechange" @on-page-size-change="pageSizeChange" :total="total" :page-size="size"
        :current="current" :page-size-opts="[50,100, 300, 500]" show-total></Page>
    </div>
  </div>
</template>
<script>
import switchc from '_c/switch/switch'
import {
  getRuleManageList,
  delRule,
  enabledRule,
  updateRuleShare
} from '@/requests/securityCenter'
export default {
  components: {
    switchc
  },
  props: ['refresh'],
  data () {
    return {
      total: 0,
      size: 50,
      current: 1,
      date: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          width: 60,
          key: 'id',
          slot:'id',
          align: 'center'
        },
        {
          title: '规则名称',
          key: 'ruleName',
          width: 300,
          ellipsis: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.date[params.index].ruleName,
              h('div', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.date[params.index].ruleName)
            ])
          }
        },
        {
          title: '规则介绍',
          key: 'ruleIntroduction',
          ellipsis: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.date[params.index].ruleIntroduction,
              h('div', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.date[params.index].ruleIntroduction)
            ])
          }
        },
        {
          title: '版本号',
          key: 'version',
          width: 60,
          align: 'center',
          slot: 'version'
        },
        {
          title: '最后更新',
          key: 'modifyTime',
          width: 130,
          align: 'center'
        },
        {
          title: '来源',
          key: 'source',
          align: 'center',
          slot: 'source',
          width: 60
        },
        {
          title: '作者',
          key: 'createBy',
          width: 60,
          slot:'createBy',
          align: 'center',
        },
        {
          title: '启用状态',
          key: 'status',
          width: 70,
          align: 'center',
          slot: 'status',
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          slot: 'action',

        }
      ],
      selectVal: ''
    }
  },
  watch: {
    size () {
      this.getRuleManageList()
    },
    refresh () {
      this.current = 1
      this.getRuleManageList()
    }
  },
  mounted () {
    this.getRuleManageList()
  },
  methods: {
    pageSizeChange (val) {
      this.size = val
      this.getRuleManageList()
    },
    pagechange (val) {
      this.current = val
      this.getRuleManageList()
    },
    askUpdate (item) {
      window.$Message.show({
        title: '更新规则',
        type: 'info',
        msg:
          '最新规则版本为：' + item.shareVersion + '。确定是否更新为此版本，更新后所有使用此规则的客户端都将在下次开机后生效！',
        cancleBtn: true,
        confirmFn: async () => {
          this.updateRuleShare(item.id)
        }
      })
    },
    async updateRuleShare (id) {
      let res = await updateRuleShare({
        id: id
      })
      if (res.code == 200) {
        this.$Notice.success({
          title: '规则更新更改，客户端重启后将生效！',
        })
        window.$Message.hide()
        this.getRuleManageList()
      } else {
        this.$Notice.warning({
          title: '更新失败',
          desc: res.msg,
        })
      }
    },
    async applySafetyRule (item) {
      let res = await window.$modal.applySafetyRule.show(
        item.ruleName,
        item.id,
        item.secGroupIds
      )
      if (res) {
        this.getRuleManageList()
      }
    },
    swichMatchFn (type, id) {
      let txt = '批量启用'; let msg
      if (type == 1) {
        txt = '批量启用'
        msg = `你确定要讲已选择的${this.selectVal.length}条规则${txt}吗`
      } else if (type == 2) {
        txt = '批量关闭'
        msg = `你确定要讲已选择的${this.selectVal.length}条规则${txt}吗`
      } else if (type == 3) {
        txt = '批量删除'
        msg = `你确定要讲已选择的${this.selectVal.length}条规则${txt}吗`
      } else {
        txt = '删除'
        msg = '你确定要删除此规则吗？'
      }
      window.$Message.show({
        title: txt + '规则',
        type: 'info',
        msg: msg,
        cancelBtn: true,
        confirmFn: async () => {
          let ids = ''
          if (type != 4) {
            this.selectVal.forEach(el => {
              if (ids != '') {
                ids += ',' + el.id
              } else {
                ids += el.id
              }
            })
          }
          if (type == 4) {
            let res = await delRule({
              id: id
            })
            if (res.code == 200) {
              window.$Message.hide()
              this.getRuleManageList()
            }
          } else if (type == 3) {
            let res = await delRule({
              id: ids
            })
            if (res.code == 200) {
              window.$Message.hide()
              this.getRuleManageList()
            }
          } else {
            let res = await enabledRule({
              type: type,
              id: ids
            })
            if (res.code == 200) {
              window.$Message.hide()
              this.getRuleManageList()
            }
          }
        }
      })
    },
    selectFn (val) {
      this.selectVal = val
    },
    async editRules (item) {
      let res = await window.$modal.editRulesModal.show(
        item.id,
        item.ruleName,
        item.ruleIntroduction,
        item.version,
        item.modifyTime
      )
      if (res) {
        this.getRuleManageList()
      }
    },
    async swichFn (item) {
      let type = 1
      if (item.status == 1) {
        type = 2
      } else {
        type = 1
      }
      let res = await enabledRule({
        id: item.id,
        type: type,
      })
      if (res.code == 200) {
        if (type == 2) {
          this.$Notice.success({ title: '规则关闭成功' })
        } else {
          this.$Notice.success({ title: '规则启用成功' })
        }
      }
      this.getRuleManageList()
    },
    async getRuleManageList () {
      let res = await getRuleManageList({
        current: this.current,
        size: this.size
      })
      if (res.code == 200) {
        res.data.records.forEach(el => {
          el.isOpen = false
          if (el.status == 1) {
            el.isOpen = true
          }
        })
        this.total = Number(res.data.total)
        this.date = res.data.records
        this.selectVal = []
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.pageCon {
  margin-top: 10px;
}
</style>
<style lang="scss" >
.tableConta {
  .ivu-table-wrapper {
    overflow: visible;
  }

  .ivu-tooltip {
    .ivu-tooltip-rel {
      width: 244px;
      word-break: keep-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ivu-tooltip-inner {
      max-width: 300px !important;
    }
  }

  .ivu-table-cell-slot {
    margin-left: 0;
  }

  .ivu-table-row {

    .ivu-btn,
    .ivu-input,
    .ivu-select-selection,
    .ivu-checkbox-border {
      line-height: 20px !important;
      height: 22px !important;
      font-size: 12px !important;
    }
  }

  .ivu-table-column-DftIvv {
    .ivu-tooltip .ivu-tooltip-rel {
      width: 190px !important;
    }
  }

  .ivu-tooltip .ivu-tooltip-rel {
    margin-top: 5px;
  }

  .ivu-table-cell {
    padding: 0 4px !important;
  }
}
</style>
